import './navitem.scss'

import {storiesOf} from '@storybook/react'
import React, {FunctionComponent} from 'react'
import {NavLink} from 'react-router-dom'
import {style} from 'util/campagne/style'
import {Link as UtilLink, LinkProps} from 'util/link'

const styles = style('navitem')

export const NavItem: FunctionComponent<LinkProps & {active?: boolean}> = ({
	children,
	className,
	active,
	...props
}) => (
	<UtilLink {...props} class={styles.mergeProps(props).is({active})}>
		<span class={styles('item')}>{children}</span>
	</UtilLink>
)
